export default "__VITE_ASSET__952fH6Jy__"